export default __webpack_public_path__ + "static/media/gangtok1.ec25b369.jpg";